import { all, put, retry, select, take, takeEvery } from "redux-saga/effects";

import { sendRequest } from "../helpers";
import prpActions from "../prp/actions";
import userActions from "../user/actionTypes";
import actionTypes from "./actionTypes";

export default function* saga() {
  yield all([
    takeEvery(actionTypes.DELETE_PAYROLL, watchDeletePayroll),
    takeEvery(actionTypes.DELETE_PAYROLL_LINE, watchDeletePayrollLine),
    takeEvery(actionTypes.DELETE_PAYROLL_LINES, watchDeletePayrollLines),
    takeEvery(actionTypes.GET_CONFIG, watchGetConfig),
    takeEvery(actionTypes.GET_CONFIG_ALERTS, watchGetConfigAlerts),
    takeEvery(actionTypes.GET_CONFIG_HOLIDAYS, watchGetConfigHolidays),
    takeEvery(actionTypes.GET_EMPLOYEE, watchGetEmployee),
    takeEvery(actionTypes.GET_LEDGER_PDF, watchGetLedgerPdf),
    takeEvery(actionTypes.GET_LEDGERS, watchGetLedgers),
    takeEvery(actionTypes.GET_LEDGERS_TOTAL, watchGetLedgersTotal),
    takeEvery(actionTypes.GET_LINE_PDF, watchGetLinePdf),
    takeEvery(actionTypes.GET_LINES_AVAILABLE, watchGetLinesAvailable),
    takeEvery(actionTypes.GET_LINES_TRANSIENT, watchGetLinesTransient),
    takeEvery(
      actionTypes.GET_LINES_TRANSIENT_TOTAL,
      watchGetLinesTransientTotal
    ),
    takeEvery(actionTypes.GET_ME_CLIENTS, watchGetMeClients),
    takeEvery(actionTypes.GET_ME_CONFIG, watchGetMeConfig),
    takeEvery(actionTypes.GET_ME_CONFIG_ALERTS, watchGetMeConfigAlerts),
    takeEvery(actionTypes.GET_ME_CONFIG_HOLIDAYS, watchGetMeConfigHolidays),
    takeEvery(actionTypes.GET_ME_INFO, watchGetMeInfo),
    takeEvery(actionTypes.GET_ME_JOB, watchGetMeJob),
    takeEvery(actionTypes.GET_ME_JOBS, watchGetMeJobs),
    takeEvery(actionTypes.GET_ME_LEDGER, watchGetMeLedger),
    takeEvery(actionTypes.GET_ME_LEDGERS, watchGetMeLedgers),
    takeEvery(actionTypes.GET_ME_LEDGERS_TOTAL, watchGetMeLedgersTotal),
    takeEvery(actionTypes.GET_ME_LINE, watchGetMeLine),
    takeEvery(actionTypes.GET_ME_LINES, watchGetMeLines),
    takeEvery(actionTypes.GET_ME_LINES_TOTAL, watchGetMeLinesTotal),
    takeEvery(actionTypes.GET_PAYROLL, watchGetPayroll),
    takeEvery(actionTypes.GET_PAYROLL_EXPORT, watchGetPayrollExport),
    takeEvery(actionTypes.GET_PAYROLLS, watchGetPayrolls),
    takeEvery(actionTypes.PATCH_LINE_SKIP, watchPatchLineSkip),
    takeEvery(actionTypes.PATCH_PAYROLL_AUTHORISE, watchPatchPayrollAuthorise),
    takeEvery(actionTypes.PATCH_PAYROLL_LINE, watchPatchPayrollLine),
    takeEvery(
      actionTypes.PATCH_PAYROLL_LINE_REVISE,
      watchPatchPayrollLineRevise
    ),
    takeEvery(actionTypes.PATCH_PAYROLL_UNLOCK, watchPatchPayrollUnlock),
    takeEvery(actionTypes.POST_CONVERT, watchPostConvert),
    takeEvery(actionTypes.POST_EXPORT_INVOICES, watchPostExportInvoices),
    takeEvery(actionTypes.POST_IMPORT_LEDGERS, watchPostImportLedgers),
    takeEvery(actionTypes.POST_LEDGERS, watchPostLedgers),
    takeEvery(actionTypes.POST_LINES_PROCESS, watchPostLinesProcess),
    takeEvery(actionTypes.POST_ME_REQUEST_CURRENCY, watchPostMeRequestCurrency),
    takeEvery(actionTypes.POST_ME_REQUEST_INVOICE, watchPostMeRequestInvoice),
    takeEvery(actionTypes.POST_PAYROLL_LINES, watchPostPayrollLines),
    takeEvery(actionTypes.POST_PAYROLL_REVISE, watchPostPayrollRevise),
    takeEvery(actionTypes.POST_PAYROLLS, watchPostPayrolls),
  ]);
}

function* watchDeletePayroll(action) {
  yield request(
    action,
    "delete",
    `payroll/${action.payload.payroll}`,
    "Payroll deleted"
  );
  yield store(actionTypes.STORE_PAYROLL, action.storageKey);
}

function* watchDeletePayrollLine(action) {
  const data = yield request(
    action,
    "delete",
    `payroll/${action.payload.payroll}/${action.payload.payrollLine}`,
    "Payout removed"
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchDeletePayrollLines(action) {
  const data = yield request(
    action,
    "delete",
    `payroll/${action.payload.payroll}/lines`,
    "Payouts removed"
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchGetConfig(action) {
  yield store(actionTypes.STORE_CONFIG, action.storageKey, []);
  const data = yield request(action, "get", "config");
  if (data && data.data) {
    yield store(actionTypes.STORE_CONFIG, action.storageKey, data.data);
  }
}

function* watchGetConfigAlerts(action) {
  yield store(actionTypes.STORE_CONFIG_ALERTS, action.storageKey, []);
  const data = yield request(action, "get", "config/alerts");
  if (data && data.data) {
    yield store(actionTypes.STORE_CONFIG_ALERTS, action.storageKey, data.data);
  }
}

function* watchGetConfigHolidays(action) {
  yield store(actionTypes.STORE_CONFIG_HOLIDAYS, action.storageKey, {
    entity: action.payload.params.entity,
    data: [],
  });
  const data = yield request(action, "get", "config/holidays");
  if (data && data.data) {
    yield store(actionTypes.STORE_CONFIG_HOLIDAYS, action.storageKey, {
      entity: action.payload.params.entity,
      data: data.data,
    });
  }
}

function* watchGetEmployee(action) {
  yield store(actionTypes.STORE_EMPLOYEE, action.storageKey);
  const data = yield request(
    action,
    "get",
    `employee/${action.payload.employee}`
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_EMPLOYEE, action.storageKey, data.data);
  }
}

function* watchGetLedgerPdf(action) {
  const data = yield request(
    action,
    "get",
    `ledger/${action.payload.ledger}/pdf`
  );
  if (data && data.data && data.data.url) {
    window.open(data.data.url, "_blank");
  }
}

function* watchGetLedgers(action) {
  yield store(actionTypes.STORE_LEDGERS, action.storageKey, []);
  const data = yield request(action, "get", "ledgers");
  if (data && data.data) {
    yield store(actionTypes.STORE_LEDGERS, action.storageKey, data.data);
  }
}

function* watchGetLedgersTotal(action) {
  yield store(actionTypes.STORE_LEDGERS_TOTAL, action.storageKey, []);
  const data = yield request(action, "get", "ledgers/total");
  if (data && data.data) {
    yield store(actionTypes.STORE_LEDGERS_TOTAL, action.storageKey, data.data);
  }
}

function* watchGetLinePdf(action) {
  const data = yield request(action, "get", `line/${action.payload.line}/pdf`);
  if (data && data.data && data.data.url) {
    window.open(data.data.url, "_blank");
  }
}

function* watchGetLinesAvailable(action) {
  yield store(actionTypes.STORE_LINES_AVAILABLE, action.storageKey, []);
  const data = yield request(action, "get", "lines/available");
  if (data && data.data) {
    yield store(
      actionTypes.STORE_LINES_AVAILABLE,
      action.storageKey,
      data.data
    );
  }
}

function* watchGetLinesTransient(action) {
  yield store(actionTypes.STORE_LINES_TRANSIENT, action.storageKey, []);
  const data = yield request(action, "get", "lines/transient");
  if (data && data.data) {
    yield store(
      actionTypes.STORE_LINES_TRANSIENT,
      action.storageKey,
      data.data
    );
  }
}

function* watchGetLinesTransientTotal(action) {
  yield store(actionTypes.STORE_LINES_TRANSIENT_TOTAL, action.storageKey, []);
  const data = yield request(action, "get", "lines/transient/total");
  if (data && data.data) {
    yield store(
      actionTypes.STORE_LINES_TRANSIENT_TOTAL,
      action.storageKey,
      data.data
    );
  }
}

function* watchGetMeClients(action) {
  yield store(actionTypes.STORE_ME_CLIENTS, action.storageKey, []);
  const data = yield request(action, "get", "me/clients");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_CLIENTS, action.storageKey, data.data);
  }
}

function* watchGetMeConfig(action) {
  yield store(actionTypes.STORE_ME_CONFIG, action.storageKey, []);
  const data = yield request(action, "get", "me/config");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_CONFIG, action.storageKey, data.data);
  }
}

function* watchGetMeConfigAlerts(action) {
  yield store(actionTypes.STORE_ME_CONFIG_ALERTS, action.storageKey, []);
  const data = yield request(action, "get", "me/config/alerts");
  if (data && data.data) {
    yield store(
      actionTypes.STORE_ME_CONFIG_ALERTS,
      action.storageKey,
      data.data
    );
  }
}

function* watchGetMeConfigHolidays(action) {
  yield store(actionTypes.STORE_ME_CONFIG_HOLIDAYS, action.storageKey, {
    entity: action.payload.params.entity,
    data: [],
  });
  const data = yield request(action, "get", "me/config/holidays");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_CONFIG_HOLIDAYS, action.storageKey, {
      entity: action.payload.params.entity,
      data: data.data,
    });
  }
}

function* watchGetMeInfo(action) {
  yield store(actionTypes.STORE_ME_INFO, action.storageKey, {});
  const data = yield request(action, "get", "me/info");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_INFO, action.storageKey, data.data);
  }
}

function* watchGetMeJob(action) {
  yield store(actionTypes.STORE_ME_JOB, action.storageKey);
  const data = yield request(action, "get", `me/job/${action.payload.job}`);
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_JOB, action.storageKey, data.data);
  }
}

function* watchGetMeJobs(action) {
  yield store(actionTypes.STORE_ME_JOBS, action.storageKey, []);
  const data = yield request(action, "get", "me/jobs");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_JOBS, action.storageKey, data.data);
  }
}

function* watchGetMeLedger(action) {
  yield store(actionTypes.STORE_ME_LEDGER, action.storageKey);
  const data = yield request(
    action,
    "get",
    `me/ledger/${action.payload.ledger}`
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_LEDGER, action.storageKey, data.data);
  }
}

function* watchGetMeLedgers(action) {
  yield store(actionTypes.STORE_ME_LEDGERS, action.storageKey, []);
  const data = yield request(action, "get", "me/ledgers");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_LEDGERS, action.storageKey, data.data);
  }
}

function* watchGetMeLedgersTotal(action) {
  yield store(actionTypes.STORE_ME_LEDGERS_TOTAL, action.storageKey, {});
  const data = yield request(action, "get", "me/ledgers/total");
  if (data && data.data && data.data[0] && data.data[0].totals) {
    yield store(
      actionTypes.STORE_ME_LEDGERS_TOTAL,
      action.storageKey,
      data.data[0].totals
    );
  }
}

function* watchGetMeLine(action) {
  yield store(actionTypes.STORE_ME_LINE, action.storageKey);
  const data = yield request(action, "get", `me/line/${action.payload.line}`);
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_LINE, action.storageKey, data.data);
  }
}

function* watchGetMeLines(action) {
  yield store(actionTypes.STORE_ME_LINES, action.storageKey, []);
  const data = yield request(action, "get", "me/lines");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_LINES, action.storageKey, data.data);
  }
}

function* watchGetMeLinesTotal(action) {
  yield store(actionTypes.STORE_ME_LINES_TOTAL, action.storageKey, {});
  const data = yield request(action, "get", "me/lines/total");
  if (data && data.data) {
    yield store(actionTypes.STORE_ME_LINES_TOTAL, action.storageKey, data.data);
  }
}

function* watchGetPayroll(action) {
  yield store(actionTypes.STORE_PAYROLL, action.storageKey);
  const data = yield request(
    action,
    "get",
    `payroll/${action.payload.payroll}`
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchGetPayrollExport(action) {
  const data = yield request(
    action,
    "get",
    `payroll/${action.payload.payroll}/export`
  );
  if (data && data.data && data.data.url) {
    window.open(data.data.url, "_blank");
  }
}

function* watchGetPayrolls(action) {
  yield store(actionTypes.STORE_PAYROLLS, action.storageKey, []);
  const data = yield request(action, "get", "payrolls");
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLLS, action.storageKey, data.data);
  }
}

function* watchPatchLineSkip(action) {
  const data = yield request(
    action,
    "patch",
    `line/${action.payload.line}/skip`,
    "Line skipped"
  );
  if (!data) {
    yield put(prpActions.getLinesAvailable());
  }
}

function* watchPatchPayrollAuthorise(action) {
  const data = yield request(
    action,
    "patch",
    `payroll/${action.payload.payroll}/authorise`,
    "Payroll authorised"
  );
  if (data && data.data) {
    yield store(actionTypes.UPDATE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchPatchPayrollLine(action) {
  const data = yield request(
    action,
    "patch",
    `payroll/${action.payload.payroll}/${action.payload.payrollLine}`,
    "Payout updated"
  );
  if (data.data) {
    yield store(actionTypes.STORE_PAYROLL_LINE, action.storageKey, data.data);

    // TODO: Can this be returned by the backend?
    const payroll = yield select((state) => state.prp.payroll);
    if (payroll && payroll.id === action.payload.payroll) {
      const lineIndex = payroll.ledgers.data.findIndex(
        (line) => line.id === data.data.id
      );
      if (lineIndex !== -1) {
        payroll.ledgers.data[lineIndex] = data.data;
        yield store(actionTypes.STORE_PAYROLL, null, {
          ...payroll,
        });
      }
    }
  }
}

function* watchPatchPayrollLineRevise(action) {
  const data = yield request(
    action,
    "patch",
    `payroll/${action.payload.payroll}/${action.payload.payrollLine}/revise`,
    "Payout reset"
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchPatchPayrollUnlock(action) {
  const data = yield request(
    action,
    "patch",
    `payroll/${action.payload.payroll}/unlock`,
    "Payroll unlocked"
  );
  if (data && data.data) {
    yield store(actionTypes.UPDATE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchPostConvert(action) {
  const data = yield request(action, "post", "convert");
  if (data && data.data && data.data.url) {
    window.open(data.data.url, "_blank");
  }
}

function* watchPostExportInvoices(action) {
  yield request(action, "post", "export/invoices", "Job added");
}

function* watchPostImportLedgers(action) {
  yield request(action, "post", "import/ledgers", "Ledgers imported");
}

function* watchPostLedgers(action) {
  yield request(action, "post", "ledgers", "Ledger created");
}

function* watchPostLinesProcess(action) {
  const data = yield request(
    action,
    "post",
    "lines/process",
    "Selected Lines processed"
  );
  if (data) {
    yield put(prpActions.getLinesAvailable());
  }
}

function* watchPostMeRequestCurrency(action) {
  yield request(action, "post", "me/request/currency");
}

function* watchPostMeRequestInvoice(action) {
  yield request(action, "post", "me/request/invoice", "Invoice Request sent");
}

function* watchPostPayrollLines(action) {
  const data = yield request(
    action,
    "post",
    `payroll/${action.payload.payroll}/lines`
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchPostPayrollRevise(action) {
  const data = yield request(
    action,
    "post",
    `payroll/${action.payload.payroll}/revise`,
    "Payroll reset"
  );
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* watchPostPayrolls(action) {
  yield store(actionTypes.STORE_PAYROLL, action.storageKey);
  const data = yield request(action, "post", "payrolls", "Payroll created");
  if (data && data.data) {
    yield store(actionTypes.STORE_PAYROLL, action.storageKey, data.data);
  }
}

function* request(action, method, url, successMessage) {
  const accessToken = yield select((state) => state.user.accessToken);
  const options = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    prefixUrl: process.env.REACT_APP_API_PRP_URL,
  };

  const response = yield sendRequest(
    action,
    method,
    url,
    options,
    successMessage
  );

  if (response.status === 401) {
    yield put({ type: "PRP_REQUEST_FAILED", payload: response });
    yield take(userActions.UPDATE_ACCESS_TOKEN);

    const newAccessToken = yield select((state) => state.user.accessToken);

    options.headers = { Authorization: `Bearer ${newAccessToken}` };

    const SECOND = 1000;
    const request = () =>
      sendRequest(action, method, url, options, successMessage);

    const { data } = yield retry(3, 10 * SECOND, request);
    return data;
  } else {
    return response.data;
  }
}

function* store(type, storageKey, payload) {
  yield put({
    payload,
    storageKey,
    type: storageKey ? actionTypes.STORE : type,
  });
}
